import React, { useEffect, useState } from "react";
import CallServiceTable from "../../components/Tables/CallServiceTable";
import { useModal } from "../../contexts/ModalContext";
import { AddNewPaymentReqForm } from "../../containers/paymentRequestsForms/AddNewPaymentReqForm";
import { Request } from "../../hooks/Request";
import { parseJsonSafe, validateArray } from "../../utils/validate";
import { Badge } from "../../components/Badge/Badge";
import { AddSubPaymentReqForm } from "../../containers/paymentRequestsForms/AddSubPaymentReqForm";
import { useDialog } from "../../contexts/DialogContext";
import { DialogConfirmation } from "../../components/Modal";
import { H3 } from "../../components/Text";
import { MinimalButton } from "../../components/Buttons/MinimalButton";
// import { ExportTransferPDF } from '../../containers/ManegeProcedure/ExportTransferPDF';
import { ExportTransferProcElementPDF } from "../../containers/ManegeProcedure/ExportTransferProcElementPDF";
import FormDefault from "../../components/Forms/FormDefault";
import * as Yup from "yup";
import { requestAuth } from "../../components/services/RequestService";
import { toast } from "react-toastify";

const PaymentRequests = ({ rol, isHistorial = false }) => {
  const [reload, setReload] = useState(false);
  const { openModal, onClose } = useModal();
  const { openDialog, dialogClose } = useDialog();
  const [permissions, setPermissions] = useState(null);

  const { data: getPermissions } = Request({
    urlApi: `dropdown/permisos-de-solicitudes/options`,
  });

  useEffect(() => {
    if (getPermissions) {
      setPermissions(parseJsonSafe(getPermissions[0]?.name));
    }
  }, [getPermissions]);

  function handleAdd(reloadTable, type) {
    openModal(
      <AddNewPaymentReqForm
        reload={reloadTable}
        onClose={onClose}
        formFields={permissions.fields.filter(
          (x) => x.rols.includes(rol) && x.formConfig === true
        )}
        type={type}
        fileRef={permissions?.openUrl}
        rol={rol}
      />
    );
  }

  function handleFillForm(val, reloadTable) {
    openModal(
      <AddSubPaymentReqForm
        item={val}
        reload={reloadTable}
        onClose={onClose}
        permissions={permissions}
        rol={rol}
      />
    );
  }
  function handleDelete(data, call) {
    openDialog(
      <DialogConfirmation
        children={<H3>¿Estas seguro que quieres eliminar el archivo?</H3>}
        onClose={dialogClose}
        method="delete"
        url={`/procElement/${data.id}`}
        texBtn="Eliminar"
        handleSuccess={call}
      />
    );
  }

  function handleExportTransferProcEl(data) {
    openDialog(<ExportTransferProcElementPDF procElement={data} />);
  }
  // function handleExportTransfer(data) {
  //     openDialog(<ExportTransferPDF procedure={data} />);
  // }
  async function onSubmit(values) {
    const details = {};
    Object.keys(values)
      .filter((key) => key.startsWith("det_"))
      .forEach((key) => {
        details[key] = values[key];
      });

    const payload = {
      num: values.num,
      details: JSON.stringify(details),
    };
    await requestAuth("put", `/procElement/${values.id}/change`, payload)
      .then(() => {
        setReload((x) => !x);
        dialogClose();
        toast.success("Registro exitoso");
      })
      .catch(() => {
        toast.error("Se produjo un error al guardar");
      });
  }

  function handleEditNum(data) {
    openDialog(
      <div className="mb-6 lg:min-w-[300px]">
        <FormDefault
          tittle={`Editar solicitud`}
          fields={[
            {
              label: "Nro. correlativo",
              name: "num",
              typeInput: "number",
            },
            {
              label: "Observaciones",
              name: "det_obs",
              typeInput: "text",
            },
          ]}
          initialValues={{
            id: data.id ?? "",
            num: data.num ?? "",
            det_obs: data.details ? JSON.parse(data.details)?.det_obs : "",
          }}
          validationSchema={Yup.object().shape()}
          onSubmit={onSubmit}
          buttonName="Registrar"
        />
      </div>
    );
  }
  return (
    <CallServiceTable
      reload={reload}
      component={({ reload }) => {
        return isHistorial ? null : (
          <div className="flex gap-1 w-68">
            <MinimalButton
              onClick={() => handleAdd(reload, "importacion")}
              text={"Agregar Solicitud"}
            />
          </div>
        );
      }}
      filters={[
        {
          name: "procedureTypeId",
          url: "/procedureType",
          default: "Todos los tramites",
          valueOption: "id",
          labelOption: "name",
        },
        {
          name: "companyId",
          url: "/company/getCompaniesBySelect",
          default: "Todas las compañías",
          valueOption: "id",
          labelOption: "razonSocial",
        },
        {
          name: "subCheck",
          // url: "/company/getallcompanies",
          default: "Todos",
          initial: "unChecked",
          options: [
            {
              label: "Completados",
              name: "checked",
            },
            {
              label: "Pendientes",
              name: "unChecked",
              // initial: true
            },
          ],
        },
        // {
        //     // url: '/company/getallcompanies',
        //     // name: 'companyId',
        //     // valueOption: 'id',
        //     // labelOption: 'razonSocial',
        //     type: "rangeDate",
        // },
      ]}
      urlApi="/procElement/pag"
      // aditionalParams={{ type: "paymentRequest", ...(isHistorial ? { fromStep: 4 } : { toStep: 3 }) }}
      // aditionalParams={{ type: "paymentRequest", ...(isHistorial ? { from: true } : { to: true }) }}
      aditionalParams={{ type: "paymentRequest" }}
      addFilters={[
        {
          name: "correlative",
          label: "Correlativo",
          filter: true,
        },
        {
          name: "stringNumber",
          label: "Tramite",
          filter: true,
        },
      ]}
      header={[
        {
          name: "num",
          label: "#",
          type: "custom",
          builder: (value, _, data) => {
            return (
              <div className="flex">
                <Badge
                  data={data?.num}
                  className="bg-gray-200 text-gray-700 px-3 py-2"
                />
              </div>
            );
          },
        },
        {
          name: "stringNumber",
          label: "Trámite",
        },
        // {
        //   name: "internCode",
        //   label: "Nro. interno",
        // },
        {
          name: "companyName",
          label: "Cliente",
        },
        {
          name: "procedureTypeName",
          label: "Flujo",
        },
        {
          name: "creationDate",
          label: "Fecha",
          type: "date",
        },
        {
          name: "checks",
          label: "Estado",
          type: "custom",
          builder: (value, sec, data) => {
            let completed = validateArray(data[sec.name])
              ? data[sec.name].filter((x) => x === true).length
              : 0;
            let pending = validateArray(data[sec.name])
              ? data[sec.name].filter((x) => x !== true).length
              : 0;
            return (
              <div className="flex flex-col gap-2">
                <Badge
                  data={`${completed} aprobados`}
                  className={
                    completed > 0
                      ? "bg-green-100 text-green-500"
                      : "bg-gray-100 text-gray-500"
                  }
                />
                <Badge
                  data={`${pending} pendientes`}
                  className={
                    pending > 0
                      ? "bg-red-100 text-red-500"
                      : "bg-gray-100 text-gray-500"
                  }
                />
              </div>
            );
          },
        },
        // {
        //     name: "Reports",
        //     type: "action",
        //     label: "Reportes",
        //     actions: [
        //         {
        //             label: "Generar informe de la recepción de documentos",
        //             icon: "fas fa-tasks",
        //             action: handleAdd,
        //             color: "text-[#1d4ed8]",
        //         },
        //     ],
        // },
        {
          name: "manage",
          type: "action",
          label: "Gestionar",
          sticky: true,
          actions: [
            {
              label: "Solicitud de transferencia (Exportación) PDF",
              icon: "far fa-file-pdf",
              action: handleExportTransferProcEl,
              color: "text-[#1d4ed8]",
            },
            // {
            //     label: "Solicitud de transferencia (Exportación) PDF",
            //     icon: "far fa-file-pdf",
            //     action: handleExportTransfer,
            //     color: "text-[#1d4ed8]",
            // },
            // {
            //     label: "Editar trámite",
            //     icon: "fas fa-edit",
            //     action: editCountryside,
            //     color: "text-[#1d4ed8]",
            // },
            ...(rol === "liq"
              ? []
              : [
                {
                  label: "Editar número correlativo",
                  icon: "fas fa-list-ol",
                  action: handleEditNum,
                  color: "text-[#1d4ed8]",
                },
              ]),
            {
              label: "Eliminar",
              icon: "fas fa-trash",
              action: handleDelete,
              color: "text-red-500",
            },
          ],
        },
      ]}
      onClick={handleFillForm}
    />
  );
};

export default PaymentRequests;
